/*
 * @Author: wangbaihe
 * @Date: 2023-04-07 17:37:09
 * @LastEditors: wangbaihe
 * @LastEditTime: 2023-11-20 09:25:23
 * @FilePath: \common-mediax\src\apis\MediaCloudNis\Tipoff.js
 * @Description:
 */
import { createAPI } from '@common'

export default {
  // 读详情
  // getNisTipoffDetail: (config) =>
  //   createAPI('customEncryptApiName-1/0w20ojt0ujqpgg0efubjm', 'get', config),
  // 读详情
  getNisTipoffDetailNoLoading: (config) =>
    createAPI('customEncryptApiName-1/0w20ojt0ujqpgg0efubjm', 'get', config, { neverLoading: true }),
  // 滚动信息读
  getNisTipoffConfigure: (config) =>
    createAPI('customEncryptApiName-1/0w20ojt0ujqpgg0dpogjhvsf', 'get', config),
// 滚动信息提交
  postNisTipoffConfigure: (config) =>
    createAPI('customEncryptApiName-1/0w20ojt0ujqpgg0dpogjhvsf', 'post', config),
  // 统计结果
  postNisTipoffDelete: (config) =>
    createAPI('customEncryptApiName-1/0w20ojt0ujqpgg0efmfuf', 'post', config),
  // 统计结果
  postNisTipoffToClue: (config) =>
    createAPI('customEncryptApiName-1/0w20ojt0ujqpgg0upDmvf', 'post', config),
  // 新---------------------
  // 获取爆料配置
  getNisTipoffConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0dpogjh', 'get', config),
  // 爆料配置保存
  postSaveNisTipoffConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0dpogjh', 'post', config),
  // 获取爆料详情
  getNisTipoffDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0efubjm', 'get', config),
  // 获取爆料详情(处理过视频的
  getNisTipoffConvert: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0efubjm0dpowfsu', 'get', config),
  // 删除爆料
  deleteNisTipoff: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0efmfuf', 'post', config),
  //下载引导页二维码
  getNisTipoffGuideQRCode: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0hvjefRSDpef', 'get', config),
  // 转为稿件
  transferNisTipoff: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0dpowfsu3Bsujdmf', 'post', config),
  // 转为稿件
  generateArticle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0hfofsbufBsujdmf', 'post', config),
  // 根据话题ids返回话题列表
  queryCircleTopicList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0upqjd0mjtu', 'post', config),
  // 根据社圈ids返回社圈列表
  queryCircleList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0djsdmf0mjtu', 'post', config),
  // 根据活动ids返回社圈列表
  queryActivityList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0bdujwjuz0hfuMjtuCzJEt', 'post', config),
  // ---------------------v2.5.15
  // 报料-新建
  addNisTipoff: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0dsfbuf', 'post', config),
  // 报料-审核通过
  postNisTipoffPass: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0qbtt', 'post', config),
  // 报料-审核不通过
  postNisTipoffReject: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0sfkfdu', 'post', config),
  // 报料-关联稿件
  postRelatedArticles: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0sfmBsujdmf', 'post', config),
  // 报料-回复
  replyNisTipoff: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0sfqmz', 'post', config),
  // 报料-查看报料回复列表
  getReplyListTipoff: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0sfqmzMjtu', 'get', config),
  // 报料-编辑报料(文字内容)
  putNisTipoffModify: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0npejgz', 'post', config),
  // 报料-删除跟进回复
  deleteReplyNisTipoff: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0efmfufSfqmz', 'post', config),
  // 报料-导出
  postTipoffExport: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt00ojt0ujqpgg0fyqpsu', 'post', config),
  // 报料-获取记者列表
  getReporterList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0sfqpsufst', 'get', config),
  // 报料-通过报料id获取关联稿件
  getRelatedArticles: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0sfmBsujdmf', 'get', config),
  // 报料-获取app端信息
  getAppInfo: (config) => createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0bqqt', 'get', config),

  // 报料-获取分组列表
  getGroups: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0dbut', 'get', config),
  // 报料-修改分组信息
  putGroups: (config) => createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0dbut', 'put', config),
  // 报料-新增分组
  postGroups: (config) => createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0dbut', 'post', config),
  // 报料-删除分组的校验
  getFolderUsedByCols: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0gpmefsVtfeCzDpmt', 'get', config, {
      neverLoading: true
    }),
  // 报料-删除分组
  deleteGroups: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0dbut0efmfuf', 'post', config),
  // 报料-分组详情
  getGroupsDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0dbut0efubjm', 'get', config),
  // 报料-回收站-列表
  getGroupsCatsRecycle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0dbut0sfdzdmf', 'get', config),
  // 报料-回收站-还原
  postGroupsCatsRestore: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0dbut0sftupsf', 'post', config),
  // 报料-按钮权限列表
  getTipoffActionPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0benjo0qfsnjttjpot0bdujpot0ojtDbu', 'get', config),
  // 报料-修改按钮权限
  postTipoffActionPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0benjo0qfsnjttjpot0bdujpot0ojt', 'post', config),
  // 报料-获取报料分组记者列表
  getTipoffReporters: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0dbut0sfqpsufst', 'get', config),
  // 报料-修改报料分组记者
  setTipoffReporters: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0dbut0sfqpsufst', 'post', config),
  // 报料-删除报料分组记者
  deleteTipoffReporters: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0dbut0sfqpsufst', 'delete', config),
  // 报料-修改报料分组顺序
  updateTipOffOrder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0dbut0vqebufPsefs', 'post', config)
}
